// Styles for DynamicPropertyCard go here.
import styled from 'styled-components';

export const StyledDynamicPropertyCard = styled.div`
  .card-layered {
    border-radius: unset !important;
    box-shadow: unset;
    .t-overline-overlay {
      font-weight: 700;
    }
  }
`;
